import {Component, OnInit} from '@angular/core';
import {TripsService} from '../../services/trips.service';
import {Trip, TripStatus} from '../../models/trip';
import {environment} from '../../../environments/environment';
import {NgbModalRef, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TripsDetailsComponent} from '../trips-details/trips-details.component';
import {CloseTripsComponent} from '../close-trips/close-trips.component';
import {getTripDurationInMin} from '../../utils/commons-utils';
import * as moment from 'moment';
import { fadeInAndOut } from '../../utils/animations-utils';
import { TranslateService } from '@ngx-translate/core';
import { ToastsManager } from 'ng2-toastr';

@Component({
  selector: 'app-trips-list',
  animations: [fadeInAndOut()],
  templateUrl: './trips-list.component.html',
  styleUrls: ['./trips-list.component.css']
})
export class TripsListComponent implements OnInit {
  p: number = 1;      // current page
  total: number;      // total count of records
  itemsPerPage = environment.itemPerPage;       // number of records to display on each page
  listLoading: boolean;
  downloading : boolean = false;
  /**
   * Keys : string criterias
   * Values : boolean => true if ascending, false otherwise
   */
  sortingCriterias: Map<string, boolean> = new Map();
  filters: Map<string, string>;

  detailsModal: NgbModalRef;

  trips: Trip[];
  listFiltered = false;

  sortByDurationLower = true;
  sortByDistanceLower = true;

  /** Filters constants */
  ID_FILTER = "t.id";
  USER = " t.applicableContract.user.email";
  GRP = "t.applicableContract.group.name";
  BIKE = "t.usedBike.name";
  START_TIME = "t.tripStartTime";
  START_STATION = "t.startStation.name";
  DURATION = "duration";
  DISTANCE_ORDER = "kmLengthLongOrder";
  DURATION_ORDER = "durationLongOrder";
  DISTANCE = "t.kmLength";
  STATUS = "t.status";

  /* Filters input that are not directly binded to this.filters */
  startTimeInput: string;
  durationInput: number;

  startTime: Date;
  duration: Date;

  /** Select options for trip status */
  selectedStatus;

  constructor(private tripService: TripsService,
              private modalService: NgbModal,
              private translate : TranslateService,
              private toast : ToastsManager) {
  }

  ngOnInit() {
    this.initFilters();
    this.getPage(1);
  }

  getPage(page: number) {
    this.p = page;
    this.listLoading = true;
    this.tripService.getPaginatedFilteredSortedStations(this.p, this.itemsPerPage, this.filters, this.sortingCriterias).subscribe(data => {
      this.trips = data.res;
      this.trips.forEach(t => t.tripStartTime = moment.utc(t.tripStartTime ).local().toDate());
      this.trips.forEach(t =>  getTripDurationInMin(t));
      this.total = data.headers.get("x-total-count");
      this.listLoading = false;
    });
  }

  /**
   * Sorting system function as follow
   * On first click on a criteria => add the criteria as ascending
   * On second click => put the critiera to descending
   * On third click => remove the criteria from the map
   */
  updateSortingCriterias(criteria: string) {
    if (this.sortingCriterias.has(criteria)) {
      if (this.sortingCriterias.get(criteria)) {   // criteria is present as true => switch to false
        this.sortingCriterias.set(criteria, !this.sortingCriterias.get(criteria));
      } else {    // criteria present as false => delete it
        this.sortingCriterias.delete(criteria);
      }
    } else {
      this.sortingCriterias.set(criteria, true);
    }
  }

  changeItemCount(value) {
    this.itemsPerPage = value;
    this.reloadList();

    localStorage.setItem("itemsPerPage", value);
  }

  initFilters() {
    this.selectedStatus = "ALL";
    this.filters = new Map();
    this.startTimeInput = "";
    this.durationInput = undefined;
  }

  clearFilters() {
    this.listFiltered = false;
    this.initFilters()
    this.reloadList();
  }

  reloadList() {
    this.listFiltered = false;
    Object.values(this.filters).forEach(value => {
      if (value) {
        this.listFiltered = true;
      }
    });

    if (this.durationInput) {
      this.filters[this.DURATION] = this.durationInput * 60;
      this.filters[this.DURATION_ORDER] = this.sortByDurationLower ? '<' : '>';
    }

    if (this.filters[this.DISTANCE]) {
      this.filters[this.DISTANCE_ORDER] = this.sortByDistanceLower ? '<' : '>';
    }

    if (this.selectedStatus == 'ALL') {
      this.filters[this.STATUS] == undefined;
    } else {
      this.filters[this.STATUS] = this.selectedStatus;
    }
    this.getPage(1);
  }

  sortBy(criteria: string) {
    this.updateSortingCriterias(criteria);
    this.reloadList();
  }

  onDetailsClick(trip: Trip) {
    this.tripService.get(trip.id).subscribe(res => {
      let formModal = this.modalService.open(TripsDetailsComponent, {size: "lg", backdrop: "static"});
      formModal.componentInstance.trip = res;
    });
  }

  onCloseClick(trip: Trip) {
    this.tripService.get(trip.id).subscribe(res => {
      let formModal = this.modalService.open(CloseTripsComponent, {centered: true});
      formModal.componentInstance.t = res;
      formModal.componentInstance.onCloseValidation.subscribe(() => this.trips.find(t => t.id == trip.id).status = TripStatus.ABNORMALLY_TERMINATED);
    });
  }

  downloadXLSFile() {
    this.downloading = true;
    this.tripService.downloadXLSFile(
      this.p,
      this.itemsPerPage,
      this.filters,
      this.sortingCriterias)
      .subscribe(isTruncated => {
        if (isTruncated) {
          this.toast.warning(this.translate.instant('common.downloadOk'));
        } else {
          this.toast.success(this.translate.instant('common.downloadTruncated'));
        }
        this.downloading = false;
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/trips/trips-list/trips-list.component.ts